import { Swiper, Navigation } from 'swiper';

Swiper.use([Navigation]);

export default (node) => {
  const sliderEl = node.querySelector('[data-slider]');
  const prevButton = node.querySelectorAll('[data-slider-pagination-prev]');
  const nextButton = node.querySelectorAll('[data-slider-pagination-next]');
  const sliderSpaceBetween = parseInt(sliderEl.dataset.spaceBetween || '16');

  let sliderBreakpoints = {
    320: 1.5,
    480: 1.5,
    768: 2.2,
    1340: 2.2,
    1800: 2.2,
  };

  const initSlider = () => {
    const swiper = new Swiper(sliderEl, {
      slidesPerView: 'auto',
      spaceBetween: sliderSpaceBetween,
      autoHeight: true,
      slidesPerGroup: 1,
      on: {
        touchStart: function () {
          // Add 'grabbing' class on touch start
          swiper.slides.forEach((slide) => {
            slide.classList.add('cursor-grabbing');
          });
        },
        touchEnd: function () {
          // Remove 'grabbing' class on touch end
          swiper.slides.forEach((slide) => {
            slide.classList.remove('cursor-grabbing');
          });
        },
      },
      breakpoints: {
        320: {
          slidesPerView: sliderBreakpoints['320'],
        },
        480: {
          slidesPerView: sliderBreakpoints['480'],
        },
        768: {
          slidesPerView: sliderBreakpoints['768'],
        },
        1340: {
          slidesPerView: sliderBreakpoints['1340'],
        },
        1800: {
          slidesPerView: sliderBreakpoints['1800'],
        },
      },
    });

    // Add event listeners to the pagination buttons because there are 2 sets of buttons in different places
    prevButton.forEach((button) => {
      button.addEventListener('click', () => {
        swiper.slidePrev();
      });
    });

    nextButton.forEach((button) => {
      button.addEventListener('click', () => {
        swiper.slideNext();
      });
    });
  };

  /**
   * Init
   */
  initSlider();
};
